import React from 'react'

const SvgMedicineBottleOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.038 2H20c1.333 0 2 .666 2 1.998v2.997c0 .666-.33 1-.993 1L21 20c0 1.333-.668 2-2.005 2H5C3.666 22 3 21.333 3 20V7.994c-.667 0-1-.333-1-.999V3.998C2 2.666 2.68 2 4.038 2zM4 3.998v1.998h16V3.998H4zm1 3.996v11.99h14V7.993H5zM11 11c0-.667.334-1 1-1 .667 0 1 .333 1 1v2l2.002-.004C15.668 13 16 13.333 16 14s-.332 1-.998 1H13v2c0 .667-.333 1-1 1-.666 0-1-.333-1-1v-2H8.997C8.332 15 8 14.667 8 14s.332-1 .997-1L11 12.996V11z'
    />
  </svg>
)

export default SvgMedicineBottleOutline
